import { useState } from "react"
import { CommaFire } from "../CommaFire"

export declare type InputProps = {
    name?: string,
    label:string,
    errorMessage?: string,
    custom_class?: string,
    checked?: boolean,
    onChange?: (e: any) => any;
    children?: JSX.Element | JSX.Element[],
    defaultValue?: any;
}
export const CMultiSelect = ({ onChange, children, defaultValue , label}: InputProps) => {

    const handelOnchange = (e: any) => {
        onChange?.(e)
    }

    return (
        <>
            <select defaultValue={defaultValue} className={` w-full h-full bg-transparent px-[10px]`} onChange={(e: any) => handelOnchange(e)} >
                {!defaultValue && label &&
                    <option className="text-sm sm:text-[11px]" value={''} selected disabled hidden>{label}</option>
                }
                {children}
            </select>
        </>
    );
}